module.exports = {
  mandiri_va: 'mandiri_va',
  bri_va: 'bri_va',
  bni_va: 'bni_va',
  qris: 'qris',
};
